(function(){
  function syncHeaderHeight(){
    var header=document.getElementById('site-header');
    if(!header)return;
    var h=header.offsetHeight;
    document.documentElement.style.setProperty('--td-header-h',h+'px');
  }
  function bootPromo(){
    var btn=document.getElementById('promo-close');
    if(!btn)return;
    btn.addEventListener('click',function(){
      document.body.classList.add('promo-hidden');
      var bar=document.getElementById('promo-bar');
      if(bar)bar.style.display='none';
      syncHeaderHeight();
    });
  }
  function bootHeaderScroll(){
    var header=document.getElementById('site-header');
    if(!header)return;
    window.addEventListener('scroll',function(){
      header.classList.toggle('is-scrolled',window.scrollY>8);
    },{passive:true});
  }
  bootPromo();
  bootHeaderScroll();
  syncHeaderHeight();
  window.addEventListener('resize',syncHeaderHeight);
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(syncHeaderHeight);}
  window.addEventListener('load',syncHeaderHeight);
  if(window.ResizeObserver){
    var headerEl=document.getElementById('site-header');
    if(headerEl)new ResizeObserver(syncHeaderHeight).observe(headerEl);
  }
})();
